import { Flex, Typography } from "antd";

import { PrimaryText, SecondaryText } from "@/components/Typography/Styled";
import { ImageRowList } from "@/components/UI/ImageRowList";

type AssignmentTaskInfoProps = {
    assignmentType: string;
    description?: string | null;
    images?: string[];
};

export const AssignmentTaskInfo = ({
    assignmentType,
    description,
    images = [],
}: AssignmentTaskInfoProps) => {
    const hasFiles = images.length > 0;

    return (
        <Flex vertical gap={8}>
            <Flex vertical gap={8}>
                <Flex gap={4}>
                    <SecondaryText>Тип доручення:</SecondaryText>
                    <PrimaryText>{assignmentType}</PrimaryText>
                </Flex>

                {!!description && (
                    <Typography
                        dangerouslySetInnerHTML={{
                            __html: description,
                        }}
                    />
                )}
            </Flex>

            {hasFiles && <ImageRowList images={images} />}
        </Flex>
    );
};
